import classNames from "classnames";
import Icon from "../Icon";
import Badge from "../Badge/Badge";
import { MaterialNames } from "../material_symbol_names";

export interface SubSectionHeadingProps {
  children: React.ReactNode;
  onClick?: () => void;
  actionIcon?: MaterialNames;
  className?: string;
  badgeCount?: number;
}

export default function SubSectionHeading({
  children,
  onClick,
  actionIcon = "navigate_next",
  className,
  badgeCount
}: SubSectionHeadingProps) {
  const headingContent = (
    <div className="flex items-center gap-2">
      <h4 className={classNames("text-title-medium-bold font-serif", className)}>{children}</h4>
      {badgeCount != null && badgeCount > 0 && <Badge value={badgeCount} testId="subsection-badge" />}
    </div>
  );

  if (onClick) {
    return (
      <div
        className={classNames("flex items-center justify-between w-full", {
          "cursor-pointer": onClick
        })}
        onClick={onClick}
      >
        {headingContent}
        {actionIcon && <Icon name={actionIcon} className="text-sys-brand-on-surface-variant" />}
      </div>
    );
  }

  return headingContent;
}
